export const testimonials = [
  {
    name: '林一舟',
    role: '消费维权用户',
    content:
      '之前自己瞎投了两个月没人理，看了这里的投稿指南把时间线重排了一遍，换了个匹配的分类渠道，一周就收到了回应。材料怎么整理真的很关键。',
  },
  {
    name: '周晓禾',
    role: '同城社区运营',
    content:
      '本地圈层的入口我们是靠这个导航找到的。分类收拾得很清楚，不用一个个去试，对刚开始做同城内容的人特别友好。',
  },
  {
    name: '陈默',
    role: '自由撰稿人',
    content:
      '最实用的是每个渠道都标了核验时间和材料要求。写稿前先扫一眼，能省掉大量无效投递，也不会把线索发到方向完全不对的地方。',
  },
  {
    name: '苏小满',
    role: '职场内容创作者',
    content:
      '隐私自保那篇我转给了好几个朋友。里面讲的截图处理和独立账号，都是平时不太会想到但确实容易被忽略的点。',
  },
  {
    name: '郑维',
    role: '车主',
    content:
      '按车型找同类问题的入口很好用，找到了一批遇到同样故障的车主，大家一起整理材料反馈，比单打独斗有力量。',
  },
  {
    name: '何念',
    role: '高校教师',
    content:
      '我把这个导航推荐给学生，主要是看中它不夸大、不煽动。每条线索都提醒先核实再传播，这种态度在现在的信息环境里很难得。',
  },
];